import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-sidebar-skeleton-loader',
    templateUrl: './sidebar-skeleton-loader.component.html',
    styleUrl: './sidebar-skeleton-loader.component.scss'
})
export class SidebarSkeletonLoaderComponent {
    @Input() isSlimMode: boolean = false;

    // Generate skeleton navigation items
    skeletonNavItems = Array(3).fill(0).map((_, i) => i);
}
